<template>
    <div>
        <footer id="footer">
                <div id="forte"><a href="http://www.forte-mice.com/"><img src="img/forte.png" alt="Forte" /></a></div>

                <div id="copyright">&copy; Copyright 2016 Corporate Travel Services Pte Ltd.</div>
            
        </footer>
    </div>
</template>

<script>
export default {
    name: 'AppFooter'
}
</script>

<style lang="less" scoped>
#footer {	
    .boxPadding;
    
    background: #fff;
    display: flex;
    flex-direction: column;
	font-size: 0.750em;
	
    position: relative;

    div {
        margin: 10px 0 10px;
    }

    #forte {
        align-self: center;
    }

	#copyright {
		background: hsla(0,100%,100%,0.5);
		line-height: 1.5em;
		padding: 0.2em 0.5em 0;
		text-align: center;
	}

	// #forte {		
	// 	a {
	// 		background: url('/img/forte.png') no-repeat left top;			
	// 		display: block;			
	// 		height: 156px;	
	// 		margin: 0 auto 1.5em;
	// 		overflow: hidden;
	// 		text-indent: -99999px;
	// 		width: 63px;			
	// 	}
	// }
}
@media only screen and (min-width : 768px) {
#footer {	
    min-width: 760px;
}
}
</style>